import { Fragment } from 'react'

interface BreakableUrlProps {
  url: string
  className?: string
}

/** Renderizza un URL lungo con punti di interruzione (<wbr/>) dopo ogni "/", così va a capo
    solo tra i segmenti del path invece di spezzare a metà parola (es. "htt" / "ps://..."). */
export function BreakableUrl({ url, className }: BreakableUrlProps) {
  const parts = url.split('/')
  return (
    <span className={className}>
      {parts.map((part, i) => (
        <Fragment key={i}>
          {part}
          {i < parts.length - 1 && (
            <>
              /<wbr />
            </>
          )}
        </Fragment>
      ))}
    </span>
  )
}
